<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="1100"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="划拨"
      @ok="handleSubmit"
    >
      <a-row>
        <a-form
          class="simiot-compact-form"
          :form="form"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 15 }"
          @submit="handleSubmit"
        >
          <a-col :span="12">
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-textarea
                :rows="20"
                :placeholder="iccidPlaceholder"
                :style="{ color: iccidValidateStatus === 'error' ? 'red' : '' }"
                v-model.trim="iccidInput"
                @blur="analyzeIccidInput"
              />
              <div style="margin-top: 8px">
                <span>ICCID总数：{{ input_profiles_count }}</span>
                <span style="margin-left: 24px">重复数量：{{ duplicate_count }}</span>
              </div>
              <div v-if="iccidErrorMsg" style="color: red; margin-top: 4px">{{ iccidErrorMsg }}</div>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="项目Profile数(个)">
              <span>{{ data.item_cards_count }}</span>
            </a-form-item>

            <a-form-item label="已划拨Profile数(个)">
              <span>{{ data.allocated_cards_count }}</span>
            </a-form-item>

            <a-form-item label="输入Profile总数(个)">
              <span>{{ input_profiles_count }}</span>
            </a-form-item>

            <a-form-item label="备注">
              <a-textarea
                :rows="3"
                v-decorator="['remark', {
                  rules: [
                    { max: 200, message: '最多200个字符' },
                  ]
                }]"
              />
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { allocateProfilesToTopAgent, findAgentPurchaseItemAllocationInfo } from '@/api/agent_purchase_item'
import { analyzeIccids, maxIccidLines } from '@/utils/iccid'

export default {
  name: 'AllocateProfilesToTopAgent',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    agentPurchaseItemId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {
        item_cards_count: 0,
        allocated_cards_count: 0
      },
      iccidInput: '',
      input_profiles_count: 0,
      duplicate_count: 0,
      parsedIccids: [],
      iccidValidateStatus: '',
      iccidErrorMsg: '',
      iccidPlaceholder: '可以直接复制excel中整列ICCID；\n' +
        '手动输入多个ICCID，一行一个。',
      form: this.$form.createForm(this, { name: 'allocate_profiles' }),
      submitting: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findAgentPurchaseItemAllocationInfo(this.agentPurchaseItemId).then((res) => {
        if (res.code === 0) {
          this.data = res.data
        }
      })
    },

    analyzeIccidInput() {
      if (!this.iccidInput) {
        this.parsedIccids = []
        this.input_profiles_count = 0
        this.duplicate_count = 0
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = '请输入 ICCID'
        return
      }

      const { lines, validIccids, errorText } = analyzeIccids(this.iccidInput)
      if (lines > maxIccidLines) {
        this.parsedIccids = []
        this.input_profiles_count = 0
        this.duplicate_count = 0
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = `ICCID数量不能超过${maxIccidLines}`
        return
      }

      this.iccidInput = errorText + validIccids.join('\n')
      this.parsedIccids = this.$lodash.uniq(validIccids)
      this.input_profiles_count = validIccids.length
      this.duplicate_count = validIccids.length - this.parsedIccids.length

      if (errorText) {
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = '号码包含错误，无法提交'
      } else if (this.parsedIccids.length === 0) {
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = '请输入 ICCID'
      } else if (this.duplicate_count > 0) {
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = '录入的 ICCID 存在重复'
      } else if (this.input_profiles_count + this.data.allocated_cards_count > this.data.item_cards_count) {
        this.iccidValidateStatus = 'error'
        this.iccidErrorMsg = 'Profile数量超过项目要求'
      } else {
        this.iccidValidateStatus = 'success'
        this.iccidErrorMsg = ''
      }
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.analyzeIccidInput()
      if (this.iccidValidateStatus === 'error') {
        return
      }

      this.form.validateFields((err, values) => {
        if (err) return

        const iccids = this.parsedIccids
        if (iccids.length === 0) {
          this.$warning({ title: '请输入有效 ICCID' })
          return
        }

        this.submitting = true
        allocateProfilesToTopAgent(this.agentPurchaseItemId, {
          iccids,
          remark: values.remark
        }).then((res) => {
          this.submitting = false
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
            this.$success({
              title: '提交成功',
              content: (
                <div>
                  <p>操作成功，具体操作结果请至 【系统查询】-【批量操作查询】 查看</p>
                </div>
              )
            })
          }
        }).catch(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>
